import { mockWorkCenters } from 'config/mockData_Scheduling';

/* ******************* The provider component ******************* */

export type SchedulingProviderValueType = {
  stateRecord: any;
};

export const defaultSchedulingState = mockWorkCenters;

export const initStateDataValue: SchedulingProviderValueType = {
  stateRecord: {
    state: defaultSchedulingState
  }
};
